import axios from "config/@axios";
import i18next from "i18next";

import * as uiActions from "store/actions/uiActions";
import * as savedSearchesActions from "./savedSearchesActions";
import * as archivesActions from "pages/Archive/store/archivesActions";

export const OPEN_LIST = "savedSearchActions::openList";
export const CLOSE_LIST = "savedSearchActions::closeList";
export const OPEN_ADD = "savedSearchActions::openAdd";
export const CLOSE_ADD = "savedSearchActions::closeAdd";
export const ADD_SAVED_SEARCH = "savedSearchActions::addSavedSearch";
export const ADD_SAVED_SEARCH_SUCCESS =
  "savedSearchActions::addSavedSearchSuccess";
export const ADD_SAVED_SEARCH_FAILED =
  "savedSearchActions::addSavedSearchFailed";
export const DELETE_SAVED_SEARCH = "savedSearchActions::deleteSavedSearch";
export const DELETE_SAVED_SEARCH_SUCCESS =
  "savedSearchActions::deleteSavedSearchSuccess";
export const DELETE_SAVED_SEARCH_FAILED =
  "savedSearchActions::deleteSavedSearchFailed";
export const FETCH_SAVED_SEARCH = "savedSearchActions::fetchSavedSearch";
export const FETCH_SAVED_SEARCH_SUCCESS =
  "savedSearchActions::fetchSavedSearchSuccess";
export const FETCH_SAVED_SEARCH_FAILED =
  "savedSearchActions::fetchSavedSearchFailed";
export const SET_SEARCH_PARAMS = "savedSearchActions::setSearchParams";
export const SET_PAGE = "savedSearchActions::setPage";
export const SET_TOTAL = "savedSearchActions::setTotal";
export const RESET_FAILED = "savedSearchActions::resetFailed";

export const openList = () => {
  return {
    type: OPEN_LIST
  };
};

export const closeList = () => {
  return {
    type: CLOSE_LIST
  };
};

export const openAdd = () => {
  return {
    type: OPEN_ADD
  };
};

export const closeAdd = () => {
  return {
    type: CLOSE_ADD
  };
};

export const addSavedSearch = data => dispatch => {
  dispatch({
    type: ADD_SAVED_SEARCH
  });

  return axios
    .post("archives/savedsearches", data)
    .then(() => {
      dispatch({
        type: ADD_SAVED_SEARCH_SUCCESS
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("archive:saved_searches.add.success_message")
        })
      );
    })
    .catch(err => {
      dispatch({
        type: ADD_SAVED_SEARCH_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const deleteSavedSearch = id => (dispatch, getState) => {
  const state = getState();
  const total = parseInt(state?.savedArchiveSearch?.totalCount) || 0;
  dispatch({
    type: DELETE_SAVED_SEARCH
  });

  return axios
    .delete(`archives/savedsearches/${id}`)
    .then(() => {
      dispatch({
        type: DELETE_SAVED_SEARCH_SUCCESS
      });
      dispatch(savedSearchesActions.deleteItem(id));
      dispatch(setTotal(total < 1 ? 0 : total - 1));
    })
    .catch(err => {
      dispatch({
        type: DELETE_SAVED_SEARCH_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const fetchSavedSearch = id => dispatch => {
  dispatch({
    type: FETCH_SAVED_SEARCH
  });

  return axios
    .get(`archives/savedsearches/${id}`)
    .then(res => {
      const {
        mailfrom = "",
        mailto = "",
        subject = "",
        subject_not_in = "",
        starttime = "",
        endtime = "",
        archiveownermail = ""
      } = res.data;

      dispatch({
        type: FETCH_SAVED_SEARCH_SUCCESS
      });
      dispatch(
        archivesActions.fetchByPage({
          page: 1,
          data: {
            mailfrom,
            mailto,
            subject,
            subject_not_in,
            starttime,
            endtime,
            archiveownermail
          }
        })
      );
    })
    .catch(err => {
      dispatch({
        type: FETCH_SAVED_SEARCH_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const setSearchParams = params => {
  return {
    type: SET_SEARCH_PARAMS,
    payload: {
      searchParams: params
    }
  };
};

export const setPage = page => {
  return {
    type: SET_PAGE,
    payload: {
      page
    }
  };
};

export const setTotal = total => {
  return {
    type: SET_TOTAL,
    payload: total
  };
};

export const resetFailed = () => {
  return {
    type: RESET_FAILED
  };
};
